<template>
    <div>

        <div :id="$props.eid">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                :groupHeaders="true"
                :rowDeselection="true"
                :rowSelection="'multiple'"

                :detailCellRendererParams="detailCellRendererParams"
                :sendToClipboard="sendToClipboard"
                :isRowMaster="isRowMaster"
                :masterDetail="true"

                :suppressDragLeaveHidesColumns="true"
                :suppressMakeColumnVisibleAfterUnGroup="true"

                :groupSelectsChildren="true"
                :groupSelectsFiltered="true"
                :rowGroupPanelShow="'always'"

                @selection-changed="onRowSelectionChanged"
                @row-double-clicked="dblClickHandler"
                overlayNoRowsTemplate="<span>No Active Alarms</span>"
                :rowHeight="36">
            </ag-grid-vue>
        </div>


        <v-dialog v-model="showAlarmDetails" max-width="80%" width="1800px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAlarmDetails = false : null}">
            <alarm-details v-if="showAlarmDetails" :alarm="selectedRows[0]" :alarmGridResources="$props.alarmGridResources" @close="showAlarmDetails = false"></alarm-details>
        </v-dialog>

        <v-dialog v-model="showAlarmTimeline" max-width="80%" width="1600px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAlarmTimeline = false : null}">
            <alarm-timeline v-if="showAlarmTimeline" :alarms="selectedRows" @close="showAlarmTimeline = false"></alarm-timeline>
        </v-dialog>

        <v-dialog v-model="showAlarmRemark" max-width="80%" width="550px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAlarmRemark = false : null}">
            <alarm-remark v-if="showAlarmRemark" @cancel="showAlarmRemark = false" @ok="addRemark"></alarm-remark>
        </v-dialog>
    
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import { CustomAggFuncs, rowColorFuncs, alarmPipeFilterParams, alarmDateFilterParams } from "@/components/Alarms/AlarmFuncs";
import AlarmTimeline from "@/components/Alarms/AlarmTimeline";
import AlarmRemark from "@/components/Alarms/AlarmRemark";
export default {
    name: 'AlarmsList',
    props: ['alarms', 'alarmGridResources', 'eid', 'parentAlarmId', 'dblClickFunc', 'disableActions'],
    components: {
        'ag-grid-vue': AgGridVue,
        AlarmTimeline,
        AlarmRemark,
        AlarmDetails: () => import("@/components/Alarms/AlarmDetails") // Need to imnport this way so recursion works.
    },
    data: () => ({
        alarmsList: [],
        showGrid: false,
        gridApi: null,
        gridOptions: {},
        detailCellRendererParams: {},
        isRowMaster: null,
        selectedRows: [],
        technicianOptions: [],
        localeOptions: [],
        siteTagOptions: [],
        issueTemplates: [],
        issueTemplatesSubmenu: [],
        showAlarmDetails: false,
        showAlarmTimeline: false,
        showAlarmRemark: false,
        alarmSubscriptionUnsubscribeFunc: null,
    }),

    computed: {
        dblClickHandler() {
            return this.$props.dblClickFunc || this.details;
        }
    },

    methods: {
        getSetFilterResources: function() {
            this.technicianOptions = this.$props.alarmGridResources.technicianOptions;
            this.localeOptions = this.$props.alarmGridResources.localeOptions;
            this.siteTagOptions = this.$props.alarmGridResources.siteTagOptions;
            // Build the context menu sublist for issue templates
            this.issueTemplatesSubmenu.push({
                name: "NO TEMPLATE",
                action: () => this.createIssue(null)
            });
            this.issueTemplates = this.$props.alarmGridResources.issueTemplates;
            for(let template of this.issueTemplates) {
                this.issueTemplatesSubmenu.push({
                    name: template.name,
                    action: () => this.createIssue(template)
                });
            }
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            let self = this;

            this.gridOptions.rowData = this.alarmsList;
            this.gridOptions.suppressContextMenu = this.$props.disableActions || false;
            this.gridOptions.deltaRowDataMode = true;
            this.gridOptions.getRowNodeId = function(data) {
                return data.alarm_id;
            };

            // this.gridOptions.columnDefs = this.createColumnDefs();

            
            // this.gridOptions.onGridReady = function(params) {
            //     self.gridOptions.api.hideOverlay();
            //     //self.gridOptions.api.sizeColumnsToFit();
            //     //self.gridOptions.columnApi.autoSizeColumns();
            //     self.gridApi = self.gridOptions.api;
            //     if(!self.$props.alarms.length) {
            //         self.gridApi.showNoRowsOverlay();
            //     }
            // }
            // this.gridOptions.defaultColDef = {
            //     sortable: true,
            //     filter: true,
            //     resizable: true
            // }

            // this.gridOptions.popupParent = this.$store.state.fullscreenElement.nodeType ? this.$store.state.fullscreenElement : document.querySelector(this.$store.state.fullscreenElement);
                        
            // this.gridOptions.onCellContextMenu = function(params) {
            //     params.node.setSelected(true, (self.selectedRows.length <= 1));
            // }
            this.gridOptions.onCellContextMenu = function(params) {
                if(params.node && params.node.group) {
                    self.gridApi.hidePopupMenu();
                    return;
                }
                params.node.setSelected(true, (self.selectedRows.length <= 1));
            }

            this.gridOptions.columnDefs = this.createColumnDefs();
            this.detailCellRendererParams = this.createSubColumnDefs();
            this.gridOptions.keepDetailRows = true;
            this.gridOptions.keepDetailRowsCount = 2;
            this.gridOptions.autoGroupColumnDef = {
                headerName: "Group",
                cellRendererParams: {
                    checkbox: true
                }
            };
            this.isRowMaster = function(data) {
                if(data.alarm_repeats) {
                }
                return (data.alarm_repeats ? true : false);
            };
            this.getRowHeight = function(params) {
                if(params.node && params.node.detail) {
                    const offset = 80;
                    return ((params.data.alarm_repeats * 28) + offset);
                }
                return (self.gridSmallMode ? 24 : 40);
            };
            this.gridOptions.suppressCellSelection = true;

            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.api.sizeColumnsToFit();
                self.defaultColumnState = self.gridOptions.columnApi.getColumnState();

                self.gridOptions.api.addAggFunc('summary', CustomAggFuncs.severitySummary);
                self.gridOptions.api.addAggFunc('highest', CustomAggFuncs.maxSeverity);
                self.gridOptions.api.addAggFunc('lowest', CustomAggFuncs.minSeverity);
                self.gridOptions.api.addAggFunc('newest', CustomAggFuncs.newestDate);
                self.gridOptions.api.addAggFunc('oldest', CustomAggFuncs.oldestDate);
                self.gridOptions.api.addAggFunc('ackCount', CustomAggFuncs.yesCount);
                self.gridOptions.api.addAggFunc('clearCount', CustomAggFuncs.yesCount);
                self.gridOptions.api.addAggFunc('saCount', CustomAggFuncs.yesCount);
                self.gridApi = self.gridOptions.api;
            }

            this.gridOptions.getContextMenuItems = function(params) {
                return [
                    {
                        name: 'Details',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.details();
                        }
                    },
                    {
                        name: 'Timeline',
                        disabled: (self.selectedRows.length > 12),
                        action: function() {
                            self.timeline();
                        }
                    },
                    'separator',
                    {
                        name: 'Acknowledge',
                        action: function() {
                            self.acknowledgeClick();
                        }
                    },
                    {
                        name: 'Clear',
                        action: function() {
                            self.clearClick();
                        }
                    },
                    {
                        name: 'Mark as Service Affecting',
                        action: function() {
                            self.markAsServiceAffectingClick();
                        }
                    },
                    'separator',
                    {
                        name: 'Add Remark',
                        action: function() {
                            self.showAlarmRemark = true;
                        }
                    },
                    'separator',
                    {
                        name: 'Un-Acknowledge',
                        action: function() {
                            self.unacknowledgeClick();
                        }
                    },
                    {
                        name: 'Un-Clear',
                        action: function() {
                            self.unclearClick();
                        }
                    },
                    {
                        name: 'Un-Mark as Service Affecting',
                        action: function() {
                            self.unMarkAsServiceAffectingClick();
                        }
                    },
                    'separator',
                    {
                        name: 'Escalate To',
                        subMenu: [
                            {   
                                name: 'Critical',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/critical')),
                                action: function() {
                                    self.escalateToClick('critical');
                                }
                            },
                            {   
                                name: 'Major',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || (self.selectedRows[0].alarm_severity == 'MAJOR') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/major')),
                                action: function() {
                                    self.escalateToClick('major');
                                }
                            },
                            {   
                                name: 'Minor',
                                disabled: ((self.selectedRows.length != 1) || (self.selectedRows[0].alarm_severity == 'CRITICAL') || (self.selectedRows[0].alarm_severity == 'MAJOR') || (self.selectedRows[0].alarm_severity == 'MINOR') || !TELSA.checkPermission(self.$store.state.user, 'alarm/escalate/minor')),
                                action: function() {
                                    self.escalateToClick('minor');
                                }
                            }
                        ]
                    },
                    'separator',
                    {
                        name: 'Create Alarm Modification',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.createAlarmModification();
                        }
                    },
                    {
                        name: 'Create Paging Rule',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.createPagingRule();
                        }
                    },
                    'separator',
                    {
                        name: 'Create Issue',
                        subMenu: self.issueTemplatesSubmenu,
                        disabled: (self.selectedRows.length > 1)
                    },
                    {
                        name: 'Site Book',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.siteBook();
                        }
                    },
                    {
                        name: 'Edit Site',
                        disabled: (self.selectedRows.length > 1),
                        action: function() {
                            self.editSite();
                        }
                    },
                    'separator',
                    'csvExport',
                    'excelExport',
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }

            // Set the row colors based on alarm severity
            this.gridOptions.getRowStyle = function(params) {
                if(!params.data) {
                    // This means that the row is a grouped row. Lets examine the leaf children and find the highest priority to color it.
                    return rowColorFuncs.getGroupRowColor(params.node.allLeafChildren, self.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
                }
                return rowColorFuncs.getRowColor(params, self.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
            }


            this.showGrid = true;
        },


        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: 'When', 
                    field: 'alarm_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    cellRenderer: "agGroupCellRenderer",
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Local Time', 
                    field: 'alarm_local_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Office', 
                    field: 'alarm_office', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Location', 
                    field: 'alarm_location', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true
                },
                {
                    headerName: 'Facility', 
                    field: 'alarm_facility_type', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true
                },
                { 
                    headerName: 'Severity', 
                    field: 'alarm_severity', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL']
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableValue: true,
                    allowedAggFuncs: ["summary", "highest", "lowest"],
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Description', 
                    field: 'alarm_description', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Rep',
                    field: 'alarm_repeats',
                    width: 150, 
                    filter: 'agNumberColumnFilter', 
                    filterParams: {
                        suppressAndOrCondition: true,
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_repeats ? params.data.alarm_repeats : '');
                    },
                    allowedAggFuncs: ['min', 'max'],
                    enableValue: true,
                },
                { 
                    headerName: 'Ack',
                    field: 'alarm_acked',
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['Yes', null]
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_ack_time.length ? "Yes" : "");
                    },
                    allowedAggFuncs: ['ackCount'],
                    enableValue: true,
                },
                { 
                    headerName: 'Clear', 
                    field: 'alarm_cleared',
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['Yes', null]
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_clear_time.length ? "Yes" : "");
                    },
                    allowedAggFuncs: ['clearCount'],
                    enableValue: true,
                },
                { 
                    headerName: 'Technician', 
                    field: 'user_username', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.technicianOptions.concat([null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Page Time', 
                    field: 'page_time',
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let page_time = "";
                        if(params.data.paged_times && params.data.paged_times.length) {
                            return params.data.paged_times.length > 1 ? '[multiple]' : params.data.paged_times[0];
                        }
                        return page_time;
                    },
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Ack Time', 
                    field: 'alarm_ack_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Clear Time', 
                    field: 'alarm_clear_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    allowedAggFuncs: ['newest', 'oldest'],
                    enableValue: true,
                },
                { 
                    headerName: 'Paged To', 
                    field: 'paged_to', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let page_to = "";
                        if(params.data.paged_users && params.data.paged_users.length) {
                            return params.data.paged_users.length > 1 ? '[multiple]' : params.data.paged_users[0].split('paged')[1];
                        }
                        return page_to;
                    }
                },
                { 
                    headerName: 'Acked By',
                    field: 'alarm_acked_by', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        if(params.data.alarm_ack_time.length) {
                            return (params.data.alarm_ack_user ? (params.data.alarm_ack_user == "SYSTEM" ? "[SYSTEM]" : params.data.alarm_ack_user) : "");
                        }
                        return "";
                    },
                },
                { 
                    headerName: 'Cleared By', 
                    field: 'alarm_cleared_by',
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        if(params.data.alarm_clear_time.length) {
                            return (params.data.alarm_clear_user ? (params.data.alarm_clear_user == "SYSTEM" ? "[SYSTEM]" : params.data.alarm_clear_user) : "[DEVICE]");
                        }
                        return "";
                    },
                },
                { 
                    headerName: 'Locale', 
                    field: 'site_locale', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.localeOptions.concat([null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Site Tags', 
                    field: 'site_tags', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.siteTagOptions.concat([null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Site Name', 
                    field: 'site_name', 
                    width: 150, 
                    filter: 'text',
                    filterParams: alarmPipeFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Service Affecting (SA)', 
                    field: 'alarm_service_affecting',
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ['Yes', null]
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return (params.data.alarm_service_affecting == 't' ? "Yes" : "");
                    },
                    allowedAggFuncs: ['saCount'],
                    enableValue: true,
                },
            ];
            return columnDefs;
        },

        createSubColumnDefs: function() {
            return {
                detailGridOptions: {
                    columnDefs: [
                        { field: "alarm_time" },
                        { field: "alarm_office" },
                        { field: "alarm_location" },
                        { field: "alarm_severity" },
                        { field: "alarm_description" }
                    ],
                    onFirstDataRendered(params) {
                        params.api.sizeColumnsToFit();
                    }
                },
                onGridReady: params => {
                    params.api.setDomLayout("autoHeight");
                },
                getDetailRowData: params => {
                    // Make alarm just have this one needed field because we dont want to send up the whole thing which could be very large(history, desc, repeats, etc....)
                    let alarm = {alarm_id: params.data.alarm_id, alarm_id_linkage_back: params.data.alarm_id_linkage_back};
                    let route = `${TELSA.apiHost}alarms/repeatlist`
                    this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                        let results = response.body;
                        params.data.repeat_list = results;
                        params.successCallback(params.data.repeat_list);
                    });
                }
            };
        },

        onRowSelectionChanged: function() {
            let selectedRows = this.gridOptions.api.getSelectedRows();
            this.selectedRows = selectedRows;
            if(this.selectedRows.length) {
                let alarmIds = this.selectedRows.map(a => a.alarm_id);
                let route = (TELSA.apiHost + "alarms/historyremarks");
                this.$http.post(route, {args: {alarmIds: alarmIds}}).then(response => {
                    let historyremarks = response.data;
                    for(let [index, alarm] of this.selectedRows.entries()) {
                        alarm.alarm_history = historyremarks[index].history;
                        alarm.alarm_remarks = historyremarks[index].remarks;
                    }
                    this.selectedRows.splice(0,0); // trigger the action drawer props to re-run computeds
                });
            }
        },

        details: function() {
            let route = (TELSA.apiHost + "alarms/details");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmId: this.selectedRows[0].alarm_id}}).then(response => {
                let result = response.body;
                this.selectedRows[0].details = result;
                this.showAlarmDetails = true;
                TELSA.loading(false);
            });
        },

        timeline: function() {
            this.showAlarmTimeline = true;
        },

        acknowledgeClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Acknowledge',
                message: `Are you sure you want to acknowledge ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.acknowledge()
            });
        },
        acknowledge: function() {
            let route = (TELSA.apiHost + "alarms/acknowledge");
            let alarmIDs = this.selectedRows.map(r => r.alarm_id);
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmIDs: alarmIDs}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>acknowledge</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        clearClick: function() {
            let children = [];
            this.selectedRows.forEach(r => {children = r.children ? children.concat(r.children) : []});
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Clear',
                message: `Are you sure you want to clear ${this.selectedRows.length + children.length > 1 ? `these ${this.selectedRows.length + children.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.clear(children)
            });
        },
        clear: function(children) {
            let route = (TELSA.apiHost + "alarms/clear");
            TELSA.loading(true);
            let alarms_id_list = this.selectedRows.map(r => r.alarm_id);
            if(children) {
                alarms_id_list = alarms_id_list.concat(children);
            }
            return this.$http.post(route, {args: {alarms: alarms_id_list}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>clear</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        markAsServiceAffectingClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Mark',
                message: `Are you sure you want to mark ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.markAsServiceAffecting()
            });
        },
        markAsServiceAffecting: function() {
            let route = (TELSA.apiHost + "alarms/serviceaffecting");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>mark service affecting</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        addRemark: function(remarkText) {
            this.showAlarmRemark = false;
            let route = (TELSA.apiHost + "alarms/remark");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows, remark: remarkText}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>add remarks</b> to the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unacknowledgeClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Acknowledge',
                message: `Are you sure you want to un-acknowledge ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unacknowledge()
            });
        },
        unacknowledge: function() {
            let route = (TELSA.apiHost + "alarms/unacknowledge");
            let alarmIDs = this.selectedRows.map(r => r.alarm_id);
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarmIDs: alarmIDs}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unacknowledge</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unclearClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Clear',
                message: `Are you sure you want to un-clear ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unclear()
            });
        },
        unclear: function() {
            let route = (TELSA.apiHost + "alarms/unclear");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unclear</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        unMarkAsServiceAffectingClick: function() {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Un-Mark',
                message: `Are you sure you want to un-mark ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.unMarkAsServiceAffecting()
            });
        },
        unMarkAsServiceAffecting: function() {
            let route = (TELSA.apiHost + "alarms/unserviceaffecting");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarms: this.selectedRows}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>unmark service affecting</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        escalateToClick: function(level) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Escalate',
                message: `Are you sure you want to escalate ${this.selectedRows.length > 1 ? `these ${this.selectedRows.length} alarms` : 'this alarm'} to ${level}?`,
                type: '',
                hideCancel: false,
                confirmAction: () => this.escalateTo(level)
            });
        },
        escalateTo: function(level) {
            let route = (TELSA.apiHost + "alarms/escalate");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: this.selectedRows[0], escalate: level}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>escalate</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        createAlarmModification: function() {
            this.$store.commit('setAlarmModificationShortcut', this.selectedRows[0]);
            this.$router.push('alarmmodifications');
        },
        createPagingRule: function() {
            this.$store.commit('setPagingRuleShortcut', this.selectedRows[0]);
            this.$router.push('pagingrules');
        },

        createIssue: function(template) {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return; // if the alarm got cleared while they had it selected then we should stop.
            }
            let route = (TELSA.apiHost + "issues/alarmdetails");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                alarm.alarm_details = result.alarm_details;
                alarm.alarm_site_id = result.alarm_site_id;
                this.$store.commit('setCreateIssueFromAlarmShortcut', {alarm: alarm, issueTemplate: template});
                this.$router.push('issues');
            });
        },

        siteBook: function() {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return;
            }
            let route = (TELSA.apiHost + "sites/getsiteid");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                let siteId = result;
                route = (TELSA.apiHost + `sites/site/${siteId}`);
                return this.$http.get(route).then(response => {
                    result = response.body;
                    let site = result.site;
                    TELSA.loading(false);
                    if(site.tree_id == -1) {
                        this.$store.commit('showConfirmModal', {
                            title: 'Site Book Help',
                            message: `The selected site has not been assigned to a tree. You can assign a tree from the 'sites' page`,
                            type: '',
                            hideCancel: true,
                            confirmAction: () => {}
                        });
                    }
                    else {
                        this.$store.commit('setEditSiteBookFromAlarmShortcut', site);
                        this.$router.push('sitebook');
                    }
                });
            });
        },

        editSite: function() {
            let alarm = this.selectedRows[0];
            if(!alarm) {
                return;
            }
            let route = (TELSA.apiHost + "sites/getsiteid");
            TELSA.loading(true);
            return this.$http.post(route, {args: {alarm: alarm}}).then(response => {
                let result = response.body;
                alarm.alarm_site_id = result;
                this.$store.commit('setEditSiteFromAlarmShortcut', alarm);
                TELSA.loading(false);
                this.$router.push('sites');
            });
        },

        sendToClipboard: function(params) {
            if(!this.selectedRows.length) {
                return;
            }
            let clipboardText = '';
            for(let [idx, row] of this.selectedRows.entries()) {
                clipboardText += `Alarm Details:\n`;
                clipboardText += `\tDescription:  ${row.alarm_description}\n`;
                clipboardText += `\tSite Name:    ${row.site_name}\n`;
                clipboardText += `\tLocation:     ${row.alarm_location}\n`;
                clipboardText += `\tOffice:       ${row.alarm_office}\n`;
                clipboardText += `\tSeverity:     ${row.alarm_severity}\n`;
                clipboardText += `\tRepeats:      ${row.alarm_repeats}\n`;
                clipboardText += `\tTime:         ${row.alarm_time}\n`;
                clipboardText += `\tAck Time:     ${row.alarm_ack_time}\n`;
                clipboardText += `\tAck User:     ${row.alarm_ack_user}\n`;
                clipboardText += `\tClear Time:   ${row.alarm_clear_time}\n`;
                clipboardText += `\tClear User:   ${row.alarm_clear_user}\n`;
                clipboardText += `\tLocale:       ${row.site_locale}\n`;
                clipboardText += `\tTechnician:   ${row.user_username}\n`;
                clipboardText += `Remarks:\n`;
                clipboardText += row.alarm_remarks.map(x => {return `\t[${x.username} at ${x.alarm_action_timestamp}] ${x.alarm_action_details}`}).join('\n');
                clipboardText += '\n';
                clipboardText += `History:\n`;
                clipboardText += row.alarm_history.map(x => {return `\t[${x.username} at ${x.alarm_action_timestamp}] ${x.alarm_action_details}`}).join('\n');

                if(idx != (this.selectedRows.length - 1)) {
                    clipboardText += "\n------------------------------------------\n\n";
                }
            }

            navigator.clipboard.writeText(clipboardText);
        },

        createAlarmSubscriptions: function() {
            this.alarmSubscriptionUnsubscribeFunc = this.$store.subscribe((mutation, state) => {
                let parentCleared = false;
                if(mutation.type == "SOCKET_ALARMS_UPDATE") {
                    let updateFound = false;
                    for(let updatedAlarm of mutation.payload) {
                        let alarmIdx = this.alarmsList.findIndex(a => a.alarm_id == updatedAlarm.alarm_id);
                        if(alarmIdx > -1) {
                            this.alarmsList[alarmIdx] = updatedAlarm;
                            updateFound = true;
                        }
                        // Check if we have a parent alarm and if that just got cleared. If yes, then we tell the parent component to close this list,
                        // because this is alarms list is being used to display children alarms.
                        if(this.$props.parentAlarmId && updatedAlarm.alarm_id == this.$props.parentAlarmId && updatedAlarm.alarm_clear_time) {
                            parentCleared = true;
                        }
                    }
                    if(updateFound) {

                        // Remove the cleared alarms
                        this.alarmsList = this.alarmsList.filter(alarm => {
                            return !alarm.alarm_clear_time;
                        });
                        this.gridApi.setRowData(this.alarmsList);
                        this.gridApi.redrawRows();
                    }
                    if(parentCleared) {
                        this.$emit('parentCleared');
                    }
                }
            }, {prepend: false});
        }
    },

    mounted() {
        this.alarmsList = this.$props.alarms;
        //this.getSetFilterResources();
        this.buildAgGrid();
        this.createAlarmSubscriptions();
    },

    destroyed() {
        this.alarmSubscriptionUnsubscribeFunc();
    }

  
};
</script>

<style scoped>


</style>
